/** Shown on org configuration and roster confirm — phone/SMS are not fully secure. */
export const ALERT_CHANNEL_AUTHORIZATION_NOTICE =
  'I confirm our organization has the required HIPAA authorizations and consents to send health-related alerts by phone and SMS for the Alert Subject. These channels are not fully secure.';
